/**
 * `/finance/settings` — configuración de cobros para el ADMIN DE ORGANIZACIÓN
 * (AUTONOMY · Layer 1).
 *
 * La misma superficie que la pestaña «Configuración» de Admin → Billing, pero
 * alcanzable por un org_admin puro: las rutas `/admin/*` exigen rol de
 * back-office de PLATAFORMA en el router web, mientras que el server autoriza
 * estos endpoints con `ManageBilling ∥ org admin`. Sin esta ruta, un dueño de
 * academia no podría configurar sus métodos/planes/descuentos sin un rol de
 * plataforma — exactamente el tipo de dependencia que AUTONOMY elimina.
 */
import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { Settings } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { BillingSettings } from "@/features/finance/components/billing-settings";

function FinanceSettingsPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="4xl">
      <div class="flex items-start justify-between gap-2">
        <PageHeader
          backTo="/finance"
          title={t(msg`Billing configuration`)}
          description={t(
            msg`Payment methods, price plans, discounts and receipt footer of your academy. Changes are audited in the activity log.`,
          )}
          icon={Settings}
        />
      </div>
      <div class="mt-4">
        <BillingSettings />
      </div>
    </PageContainer>
  );
}

export const financeSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/finance/settings",
  component: withFeatureGate("billing.core", FinanceSettingsPage),
});
